export default __webpack_public_path__ + "static/media/product-01.07891989.jpg";